import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import env from '@travel/env';

import { logout } from 'store/authCode/actions';
import { getError, getItem } from 'store/authCode/selectors';

const useHeaderEvents = () => {
  const dispatch = useDispatch();
  // if local env (mock-api), we will not trigger OMNI when token does not exist
  const isDevelopmentEnv = env('UNIVERSAL_API_MOCK_SERVER') === 'true';

  const item = useSelector(getItem);
  const error = useSelector(getError);

  const isMaintenanceMode = error?.status === 503;

  useEffect(() => {
    // to trigger login if there is no token

    // mock-env: skip forced user login on any error condition
    // non-mock-env: whenever there is no token or auth api is error, force user to login

    const submitLogin = () => {
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = 'https://auth.travel.rakuten.co.jp/fwd/memberDispatcher/login';
      form.style.display = 'none';

      const data = {
        return_url: 'cgi-bin/rakuten_id_reference',
        service_id: 'omnit01',
        f_next_url: window.location.href,
      };

      Object.entries(data).forEach(([key, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = value;
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();
    };

    const triggerLogin = () => {
      if (!isMaintenanceMode && !isDevelopmentEnv && (!item?.token || Boolean(error?.status))) {
        submitLogin();
      }
    };
    window.addEventListener('load', triggerLogin);

    return () => {
      window.removeEventListener('load', triggerLogin);
    };
  }, [error?.status, isDevelopmentEnv, isMaintenanceMode, item?.token]);

  // to register logout event
  useEffect(() => {
    function triggerLogout() {
      dispatch(logout());
    }

    document.addEventListener('HEADER_EVENT_LOGOUT', triggerLogout, false);
    return () => {
      document.removeEventListener('HEADER_EVENT_LOGOUT', triggerLogout, false);
    };
  }, [dispatch]);

  // to replace url to href path as the redirect url will have "?" (current platform rule)
  // only case "<url>?" after OMNI login will be replaced
  useEffect(() => {
    const pathRegex = new RegExp('\\?$');
    if (pathRegex.test(window.location.href)) {
      const href = window.location.href;
      window.history.replaceState({}, '', href.substring(0, href.length - 1));
    }
  });
};

export default useHeaderEvents;
